import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { staffApi } from '../api/staff';
import { CreateOrUpdateAdmin } from '../types/Staff';

export const useCreateAdminUser = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (adminUser: CreateOrUpdateAdmin) =>
      staffApi.createAdminUser(adminUser),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['adminUsers'] });
      message.success(`Usuário cadastrado com sucesso.`);
    },
    onError: () => {
      message.error(`O usuário não foi cadastrado. Tente novamente.`);
    },
  });

  const { mutateAsync, isPending: isLoading, ...rest } = mutation;

  return { mutateAsync, isLoading, ...rest };
};
